<template>
  <div>
    <!-- 卡片列表 -->
    <div v-loading="loading"
         class="card-item-list">
      <div class="card-items"
           v-for="(o, index) in itemList"
           :key="index">
        <el-card shadow="hover"
                 :body-style="{ padding: '0px' }">

          <!-- 整个div -->
          <div class="card-item">
            <!-- 图片 -->
            <div class="content_image">
              <img class="image"
                   :style="imageSize"
                   @click="clickCard(o)"
                   :src="o.image" />
              <!-- 角明细 -->
              <div v-if="o.corner_name!==''"
                   class="content_dest">|{{o.corner_name}}</div>
            </div>
            <!-- 文字 -->
            <div class="content_text">
              <!-- 产品标题:有2行，超过之后用... 显示 -->
              <div @click="clickCard">
                <h3 class="card-text-title">
                  {{ o.title.length > 14? o.title.slice(0, 14) + '...' :o.title }}
                </h3>
                <!-- 下标题 -->
                <div v-if="showMiniTitle"
                     style="color: grey;height:50px">
                  <span v-if="o.title_mini"
                        style="font-size: 5px;">{{titleMiniName}}</span>
                  <span class="under-title"
                        v-html="o.title_mini">
                  </span>
                </div>
                <!-- 下标题结束 -->
              </div>
              <!-- 标签 -->
              <div v-if="showTag">
                <span style="font-size: 13px">标签:</span>
                <el-tag style="margin-left: 5px"
                        v-for="(tag_item, index) in o.tag"
                        :key="index"
                        size="mini"
                        type="">
                  {{tag_item.tag_name}}
                </el-tag>
              </div>
              <!-- 目的地 -->
              <div v-if="showDest">
                <span style="font-size: 13px">目的地:</span>
                <el-tag style="margin-left: 5px"
                        v-for="(locitem) in o.dest"
                        :key="locitem.id"
                        size="mini"
                        type="info">{{ locitem }}</el-tag>
              </div>
              <div class="content-text-bottom-item">
                <!-- 更新于日期 -->
                <div v-if="showUpdate"
                     class="time">更新于: {{ o.update_time }}</div>
                <!-- 添加按钮 -->
                <el-button v-if="checked_list.indexOf(o.id)>-1"
                           class="content-text-bottom-button"
                           @click="checkedItem(o)"
                           style="color:green"
                           icon="el-icon-success"
                           type="text">{{buttonName}}</el-button>
                <!-- 已选按钮 -->
                <el-button v-else
                           @click="checkedItem(o)"
                           type="text"
                           class="content-text-bottom-button"
                           icon="el-icon-circle-plus">
                </el-button>
              </div>
            </div>
            <!-- 文字结束 -->
          </div>
        </el-card>
      </div>
      <!-- 却一个时候填充的模块 -->
      <div class="card-items"
           v-if="itemList.length != 9"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'card-check-list',
  data() {
    return {
      imageSize: `  height: ${this.imageHeight}px; width: ${this.imageWidth}px;`,
      loading: false,
      itemList: this.cardList,
      isChecked: -1,
      // 已选列表
      checked_list: [],
    }
  },
  watch: {
    cardList(val) {
      this.itemList = val
    },
  },
  props: {
    cardList: {
      type: Array,
      default: () => {
        return [{}, {}, {}, {}]
      },
    },
    titleMiniName: {
      type: String,
      default: '下标题名称:',
    },
    showMiniTitle: {
      type: Boolean,
      default: true,
    },
    // 显示功能区
    showTitleImage: {
      type: Boolean,
      default: true,
    },
    buttonName: {
      type: String,
      default: '按钮',
    },
    showDest: {
      type: Boolean,
      default: true,
    },
    showTag: {
      type: Boolean,
      default: true,
    },
    showUpdate: {
      type: Boolean,
      default: true,
    },
    // 图片设置  147 *235
    imageHeight: {
      type: Number,
      default: 49.8,
    },
    imageWidth: {
      type: Number,
      default: 94,
    },
  },
  methods: {
    clickCard() {},
    checkedItem(value) {
      // console.log(this.checked_list)

      let arrItemIndex = this.checked_list.indexOf(value.id)
      if (arrItemIndex > -1) {
        this.checked_list.splice(arrItemIndex, 1)
      } else {
        this.checked_list.push(value.id)
      }
      this.$emit('checkedItem', this.checked_list)
    },
  },
}
</script>

<style>
/* 基本 */
.image {
  display: block;
  cursor: pointer;
}
/* 封面元素 */
.content_dest {
  position: absolute;
  font-size: 13px;
  color: #fff;
  padding: 0 10px;
  background-color: #ff5421;
  width: 79%;
  text-align: center;
  bottom: 0%;
  left: 0%;
}

/* 卡片 */
.card-item-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  /* align-items: flex-start; */
  align-content: flex-start;
}
.card-items {
  width: 32%;
  margin: 5px;
  /* cursor 光标属性，可以添加click事件 */
}

/* 单个卡片样式 */
.card-item {
  display: flex;
  position: relative;

  /* justify-content: space-between; */
}

.content_image {
  position: relative;
}
.content_text {
  width: 100%;
  margin: 3px;
}
.card-text-title {
  font-size: 14px;
  word-break: keep-all;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
}

.content-text-bottom-item {
  display: flex;
  /* margin-top: 5px; */
  justify-content: space-between;
}

.content-text-bottom-button {
  font-size: 15px;
  padding: 0;
  /* width: 100%; */
  /* float: right; */
  margin-left: auto;
  /* text-align: right; */
}

.under-title {
  word-break: keep-all;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>